import { useState } from 'react';
import { PanelGrid } from '@/components/PanelGrid';
import { IncidentList } from '@/panels/IncidentList';
import { ControlChart } from '@/panels/ControlChart';
import { SLACompliance } from '@/panels/SLACompliance';
import { KPIDashboard } from '@/panels/KPIDashboard';
import { PendingReview } from '@/panels/PendingReview';
import { IncidentDetailModal } from '@/panels/IncidentDetailModal';

export function IncidentsView() {
  const [selectedIncident, setSelectedIncident] = useState<string | null>(null);

  return (
    <div data-testid="ops-view-incidents">
      <PanelGrid>
        <IncidentList />
        <KPIDashboard />
        <SLACompliance />
        <ControlChart />
        <PendingReview />
      </PanelGrid>
      <IncidentDetailModal
        incidentId={selectedIncident}
        onClose={() => setSelectedIncident(null)}
      />
    </div>
  );
}
